import { URL_REGEX } from "lib/regexes";

const urlRegex = new RegExp(URL_REGEX, "g");

export default (text: string): Array<string> => text.match(urlRegex) || [];
